import type { OpenHouse } from '@bb/domain/dist/types/Listing';
import Axios from 'axios';

const getRepsAndOpenHousesForListing = async (listingId: string) => {
  const { data } = await Axios.get<{ reps: string[]; openHouses: OpenHouse[] }>(
    `/listing/${listingId}/reps_and_open_houses`,
  );
  return data;
};
export default getRepsAndOpenHousesForListing;
